import { default as Services } from '../services/base.Services.js';
import { default as Utils } from '../utils/base.Utils';

const ENUM_MAP_TYPE = {ROOT: 'ROOT', CITY: 'CITY', BUILDING: 'BUILDING', FLOOR: 'FLOOR'}
export default class UtilsMap {

  static get MapType() { return ENUM_MAP_TYPE }
  static getMapsTree(resolve, reject) {
    return new Promise((resolve, reject) => {
        let tmp = {};
        UtilsMap.getTree(null, tmp).then(() => {
            resolve(tmp.children[0]);
        });
    });
  }

  static getTree(id, dest) {
    return new Promise((resolve, reject) => {
      Services.FindAndBook.getChildrenMaps(id, false).then(ret => {
        let promises = [];

        dest.children = ret.data.SearchChildrenMapsResult.Items;
        dest.children.forEach(item => {
          if(item.ChildrenMapCount)
            promises.push(UtilsMap.getTree(item.ID, item));
        })

        Promise.all(promises).then(() => {
            resolve();
        })
      }, fault => {
          reject();
      }).catch(err => {
          reject();
      });
    });
  }

  static getMapsFlatTree(idMap, flatTree) {
    let mapsArray = flatTree.find(arr => {
      return arr[arr.length-1].ID == idMap;
    })
    if(!mapsArray) {
      mapsArray = flatTree.find(arr => {
        return arr[arr.length-2].ID == idMap;
      })
    }
    return mapsArray;
  }

  static getPoiImageMap(poi) {
    let mapsArray = UtilsMap.getMapsFlatTree(poi.IDMap, App.officeMapsFlatTree);
    return mapsArray && mapsArray[mapsArray.length-1] ? mapsArray[mapsArray.length-1].ImageURL : '';
  }

  static getPoiLocation(poi, flatTree) {
    let mapsArray = UtilsMap.getMapsFlatTree(poi.IDMap, flatTree);
    let path = '';
    if(!Array.isArray(mapsArray)) return path;
    mapsArray.forEach((map, index) => {
      path += map.Name;
      if(mapsArray.length -1 != index)
        path += ' - ';
    });
    return path;
  }

  static getPoiParkingLocation(poi) {
    let _indexParking = -1;
    const parking = App.listParking.find(parkByoffice => {
      const indexParking = parkByoffice.parkings.findIndex(parking => parking.ID === poi.IDMap)
      if(indexParking != -1) {
        _indexParking = indexParking;
        return true;
      }
    }
      
    );
    if(parking && _indexParking != -1) {
      return parking.parkings[_indexParking].locationName;
    }
    return '';
  }

  static getPOITypeListMappingByFunc(poiList, poiType, func) {
    function groupBy(list, keyGetter) {
      const map = new Map();
      list.forEach((item) => {
           const key = keyGetter(item);
           const collection = map.get(key);
           if (!collection) {
               map.set(key, [item]);
           } else {
               collection.push(item);
           }
      });
      return map;
    }
    if(Array.isArray(poiList))
      return groupBy(
        poiList.filter(poi => Utils.Metadata.getMetadataValuesByID(poi.Metadata, 'poiType').toLowerCase() == poiType.toLowerCase()),
        func
      );
  }

  static getOfficeMapsListWithPOI(poiList, poiType) {

    if(Array.isArray(poiList) && poiType != null){
      const poiListMapped = UtilsMap.getPOITypeListMappingByFunc(poiList, poiType, poi => poi.IDMap);

      return App.officeMapsList.filter(office => {
        return office 
          ? office.floors && office.floors.length > 0 
              ? office.floors.filter(floor => poiListMapped.has(floor.ID)) != undefined
              : office.children && office.children.length > 0
                ? office.children.find(child => poiListMapped.has(child.ID)) != undefined
                : false
          : false;
        });
    } else return [];
  }

  static getOfficeMapsTree(map, newTree) {
    newTree.children =  map && Array.isArray(map.children) ? map.children.filter(m => m.MapType != 'PARKING'): [];
    newTree.children.forEach(c => {
      UtilsMap.getOfficeMapsTree(c, c);
    })
    return newTree;
  }

  static getParkingMapsTree(map, newTree) {
    newTree.children =  map && Array.isArray(map.children) ? map.children.filter(m => m.MapType != 'OFFICE'): [];
    newTree.children.forEach(c => {
      UtilsMap.getParkingMapsTree(c, c);
    })
    return newTree;
  }

  static getRoomMapsTree(map, newTree) {
    newTree.children =  map && Array.isArray(map.children) ? map.children.filter(m => m.MapType != 'PARKING'): [];
    newTree.children.forEach(c => {
      UtilsMap.getRoomMapsTree(c, c);
    })
    return newTree;
  }

  static getMapFromTreeById(map, id, searchInFloor = false) {
    if(map.ID != undefined && map.ID === id)
      return map;
    else if(searchInFloor && map.HasFloors){
        let result = null;
        for(let i=0; result == null && i < map.MapFloor.length; i++ ){
          result = UtilsMap.getMapFromTreeById(map.MapFloor[i], id, searchInFloor);
        }
        return result;
      }
    else if(map.children){
      let result = null;
      for(let i=0; result == null && i < map.children.length; i++ ){
        result = UtilsMap.getMapFromTreeById(map.children[i], id, searchInFloor);
      }
      return result;
    }
    return null
  }

  /**
   * Prendi un albero e visitalo tutto finchè non trovi un ID contenuto in idArray
   * Non considerare quelli che stanno sotto
   * @param {*} node Il nodo da visitare
   * @param {*} idArray L'array di ID
   */
  static getFirstEnabledIDs(node, idArray)
  {
    const result = [];
    if (idArray.includes(node.ID))
    {
      result.push(node.ID);
    }

    //Se abbiamo avuto almeno un risultato abbiamo GIA trovato quello che cercavamo.
    if (result.length > 0) {
      return result;
    }

    //In caso contrario continuiamo ricorsivamente
    if (node.children.length)
    {
      for (const child of node.children)
      {
        //Includi i risultati che trovi in questa lista
        result.push(this.getFirstEnabledIDs(child, idArray));
      }
    }

    return result.flat(Infinity);
  }

  // Pass recursively through mapTree and:
  // 1 - Delete ID of a map if it's not included in App.deskAnalyticsMapEnabledList
  // 2 - Delete the entire map if the ID it's not included and either every children's map ID
  static getEnabledMapTree(mapTree, skipIDMapCheck = false, arrayIDSMapEnabled = App.deskAnalyticsMapEnabledList) {
    if(mapTree.children.length) {
      if(skipIDMapCheck || arrayIDSMapEnabled.includes(mapTree.ID)) {
        return mapTree;
      } else {
        delete mapTree.ID;
        mapTree.children = mapTree.children.map(child => UtilsMap.getEnabledMapTree(child, skipIDMapCheck, arrayIDSMapEnabled)).filter(map => map != null);
        if(mapTree.children.length)
          return mapTree;
      }
    } 
    else {
      if(skipIDMapCheck || arrayIDSMapEnabled.includes(mapTree.ID)) {
        return mapTree;
      }
    }
  }

  //Removes all leaves from the map. Keeps all maps of type ROOT, CITY, CAMPUS and BUILDING
  static removeLeavesFromMapTree(mapTree) {
    if(UtilsMap.getMapsChildren(mapTree).length) {
      mapTree.children = mapTree.children.map(child => UtilsMap.removeLeavesFromMapTree(child)).filter(map => map != null);
      return mapTree;
    } else {
      return mapTree.HasFloors || ['ROOT', 'CITY', 'CAMPUS', 'BUILDING'].includes(mapTree.MapType) ? mapTree : null;
    }
  }

  static getMapsParkings(selectedMap) {
    //Funzione creata a parte perchè non ho voglia di risolvere i casini della getMapsChildren
    if (selectedMap && selectedMap.ID)
    {
      //Nel caso la mappa selezionata sia un figlio ritorna la mappa
      if (selectedMap.children.length == 0)
        return [selectedMap];
      
      let mapsChildren = [];

      //Riciclo la chiamata nel caso controllo per una città
      const cityCheck = function(city, mapsChildren)
      {
        city.children.forEach(element => {            
          let childMapType = element.MapType.toLowerCase();

          if (childMapType === 'parking')
          {
            mapsChildren.push(element);
          }
          //I building possono contenere i parking. Conviene analizzare i suoi figli
          else if (childMapType === 'building') {
            buildingCheck(element, mapsChildren);
          }
          //Siamo nel caso dei campus. I campus possono contenere edifici.
          else if (childMapType === 'campus') {
            //Controlla ogni elemento del campus
            element.children.forEach(building => { 
              if (building.MapType.toLowerCase() === 'parking')
              {
                mapsChildren.push(building);
              }
              else if (building.MapType.toLowerCase() === 'building') {
                buildingCheck(building, mapsChildren);
              }
            });
          }
        });
      }

      //Visto che devo eseguire le stesse cose per campus e building riciclo la funzione
      const buildingCheck = function(element, mapsChildren)
      {
        //I building possono contenere i parking. Conviene analizzare i suoi figli
        element.children.forEach(parking => {
          //Aggiungi l'elemento se, come pensiamo, è un parcheggio.
          if (parking.MapType.toLowerCase() == 'parking')
          {
            mapsChildren.push(parking);
          }
        })
      }
      const mapType = selectedMap.MapType.toLowerCase();
      switch(mapType)
      {
        case 'root':
          selectedMap.children.forEach(city => {
            if (city.MapType.toLowerCase() == 'parking')
            {
              mapsChildren.push(city);
            }
            else
            {
              cityCheck(city, mapsChildren); 
            }  
          });
        break;
        case 'city':
          cityCheck(selectedMap, mapsChildren);
        break;
        case 'building':
          buildingCheck(selectedMap, mapsChildren);
        break;
        default:
          mapsChildren = selectedMap.children;
      }
      return mapsChildren;
    }
    return [];
  }

  static getMapsChildren(selectedMap) {

    if(selectedMap && selectedMap.ID) {
      const mapType = selectedMap.MapType.toLowerCase();

      // root
      //   city
      //     campus (optz)
      //       building 
      //         floor (livello o mappa)
      //           area (optz)
      //             office (optz)
      let mapsChildren = [];
      switch(mapType) {
        case 'root': {
          //scorro le cities e prendo i loro figli se sono building o i figli dei figli se sono campus
          selectedMap.children.forEach(c => {
            c.children.forEach(cc => {            
              let childMapType = cc.MapType.toLowerCase();
              if(childMapType === 'building')
                mapsChildren.push(cc); // cc è un building
              else if (childMapType === 'campus') {
                cc.children.forEach(ccc => { 
                  let childCampusMapType = ccc.MapType.toLowerCase();
                  if(childCampusMapType === 'building')
                    mapsChildren.push(ccc); // ccc è un building
                });
              }
            });          
          });
          break;
        }
        case 'city': {
          //scorro i figli delle cities che possono essere campus o building
          selectedMap.children.forEach(c => {
            let childMapType = c.MapType.toLowerCase();
            if(childMapType === 'building')
              mapsChildren.push(c); // cc è un building
            else if (childMapType === 'campus') {
              c.children.forEach(cc => { 
                let childCampusMapType = cc.MapType.toLowerCase();
                if(childCampusMapType === 'building')
                  mapsChildren.push(cc); // cc è un building
              });
            }
          });
          break;
        }
        case 'building': {
          mapsChildren = selectedMap.HasFloors ? selectedMap.MapFloor : selectedMap.children;
          break;
        }
        default : {
          //se sono campus i figli sono sicuramente building
          mapsChildren = selectedMap.children;
  
          break;
        }
      }
      return mapsChildren;
    } else return [];
  }
}
